import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { focusStyle } from '../styles/mixins';
import { fontText, StylesIndexInjections } from 'common-react';
import { blendRGBA, themeColorsRgba } from '../theme/tools/theme.utils';

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    padding: '4px 16px',
    backgroundColor: theme.color.greys[10],
    borderRadius: 8,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    border: 'none',
    height: 'auto',
    '&:hover': {
      borderColor: 'none',
      backgroundColor: themeColorsRgba(theme).black8,
    },
    '&:active': {
      boxShadow: 'none',
    },
    '&:focus': {
      backgroundColor: theme.color.greys[10],
    },
    '&:focus-visible': {
      ...focusStyle
    },
  },

  focusVisible: {
    ...focusStyle(theme),
    backgroundColor: theme.color.greys[0],
  },

  deleteIcon: {
    width: 20,
    height: 20,
    textAlign: 'center',
    margin: '0 0 0 6px',
    color: theme.color.greys[80],
    '&:hover': {
      color: theme.color.greys[80],
    },
  },

  label: {
    textOverflow: 'ellipsis',
    whiteSpace: 'pre-wrap',
    overflow: 'hidden',
    font: fontText('normal', theme.fontSize.base, 24),
    color: theme.color.greys[80],
    padding: 0
  },

  clearFilters: {
    backgroundColor: themeColorsRgba(theme).primary12,
    '& .MuiChip-deleteIcon': {
      color: theme.color.reds[100],
    },
    '&:hover': {
      backgroundColor: blendRGBA(themeColorsRgba(theme).primary12, themeColorsRgba(theme).black8),
    },
  }
}), { name: 'Chip', index: StylesIndexInjections.UI_ATOMS });
